// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2UOao","productName":"Table_productName__120BN"};